const leaderboardScoresColumnData = [
  {
    Header: 'Rank',
    accessor: 'rank',
    Cell: ({ row }) => row.original.rank || '-'
  },
  {
    Header: 'Username',
    accessor: 'username',
    Cell: ({ row }) => row.original.username || '-'
  },
  {
    Header: 'Player ID',
    accessor: 'playerId',
    Cell: ({ row }) => row.original.playerId || '-'
  },
  {
    Header: 'Score',
    accessor: 'score',
    Cell: ({ row }) => Number(row.original.score || 0).toFixed(2)
  }
];

export default leaderboardScoresColumnData;
